export const PROJECT_TYPES = [
    {
        label: "Monthly",
        value: 0,
    },
    {
        label: "Daily Rental",
        value: 1,
    },
];

export const PAST_PERIODS = [
    {
        label: "Last 24 hrs",
        value: 0,
    },
    {
        label: "Last Week",
        value: 1,
    },
    {
        label: "Last month",
        value: 2,
    },
    {
        label: "Last 3 months",
        value: 3,
    },
    {
        label: "Last 6 months",
        value: 4,
    },
    {
        label: "Last Year",
        value: 5,
    },
];

export const UPCOMING_PERIODS = [
    {
        label: "24 hrs",
        value: 0,
    },
    {
        label: "This Week",
        value: 1,
    },
    {
        label: "This month",
        value: 2,
    },
    {
        label: "Next 3 months",
        value: 3,
    },
    {
        label: "Next 6 months",
        value: 4,
    },
    {
        label: "Next Year",
        value: 5,
    },
];

export const PROJECT_STATUS = [
    {
        label: "Pending Review",
        value: "pending_review",
    },
    {
        label: "Deactivated",
        value: "deactivated",
    },
    {
        label: "Declined",
        value: "declined",
    },
    {
        label: "Approved",
        value: "approved",
    },
];
